define('settings/lib/attendees/attendees',['require','knockout','durandal/app','i18next','api-access','mixpanel-helper','web-urls'],function (require) {
    var ko = require('knockout');
    var app = require('durandal/app');
    var i18n = require('i18next');
    var userApi = require('api-access').user;
    var mixpanelHelper = require('mixpanel-helper');
    var presenterSwapEnabled = require('web-urls').get('presenterSwap', 'features');
    var MODERATED = 'moderated';
    var OPEN = 'open';
    var mixPanelConstants = {
        PRESENTER_SWAP_SETTING: 'presenterSwapSetting',
        ON: 'on',
        OFF: 'off',
        ACTIVATE_WEB_VIEWER: 'Activate Web Viewer',
        DEACTIVATE_WEB_VIEWER: 'Deactivate Web Viewer'
    };

    var toPresenterMode = function (selected) {
        return selected ? OPEN : MODERATED;
    };

    var defaultPresenterMode = function (setting) {
        return setting.presenterMode ? setting.presenterMode : MODERATED;
    };

    var isPresenterModeOpen = function (setting) {
        return defaultPresenterMode(setting) === OPEN;
    };

    var reset = function (self) {
        self.isWebViewerSelected(self.originalSettings().webViewer);
        self.isWebJoinEnabledSelected(self.originalSettings().webAppLite);
        self.isOpenPresenterModeSelected(isPresenterModeOpen(self.originalSettings()));
    };

    return function () {
        var self = this;

        self.originalSettings = ko.observable({});

        self.isWebJoinProvisioned = ko.observable();
        self.descriptionText = ko.observable();
        self.isWebViewerAllowed = ko.observable();

        self.isWebJoinEnabledSelected = ko.observable();
        self.isWebViewerSelected = ko.observable();

        self.webViewerVideoUrl = i18n.translate('web-urls.urls.g2m.webviewer.video');
        self.webAppMoreInfoUrl = i18n.translate('web-urls.urls.g2m.webapp.more');

        self.presenterSwapEnabled = presenterSwapEnabled;
        self.isOpenPresenterModeSelected = ko.observable();
        self.isOpenPresenterRelatedFeaturesEnabled = ko.observable(true);

        self.showSaveBox = ko.computed(function () {
            return (
                self.isWebViewerSelected() !== self.originalSettings().webViewer ||
                self.isWebJoinEnabledSelected() !== self.originalSettings().webAppLite ||
                toPresenterMode(self.isOpenPresenterModeSelected()) !== self.originalSettings().presenterMode
            );
        });

        self.save = function () {
            return userApi
                .updateSettings({
                    webViewerDefault: self.isWebViewerSelected(),
                    isWebJoinEnabled: self.isWebJoinEnabledSelected(),
                    presenterMode: toPresenterMode(self.isOpenPresenterModeSelected())
                })
                .then(function () {
                    app.trigger('settings:save');
                    self.originalSettings({
                        webViewer: self.isWebViewerSelected(),
                        webAppLite: self.isWebJoinEnabledSelected(),
                        presenterMode: toPresenterMode(self.isOpenPresenterModeSelected())
                    });
                })
                .then(function () {
                    // check this behavior with victor
                    if (self.isWebViewerSelected()) {
                        mixpanelHelper.track(mixPanelConstants.ACTIVATE_WEB_VIEWER);
                    } else {
                        mixpanelHelper.track(mixPanelConstants.DEACTIVATE_WEB_VIEWER);
                    }
                    if (self.isOpenPresenterModeSelected()) {
                        mixpanelHelper.track(mixPanelConstants.PRESENTER_SWAP_SETTING, {
                            action: mixPanelConstants.ON
                        });
                    } else {
                        mixpanelHelper.track(mixPanelConstants.PRESENTER_SWAP_SETTING, {
                            action: mixPanelConstants.OFF
                        });
                    }
                })
                .fail(function () {
                    reset(self);
                });
        };

        self.cancel = function () {
            reset(self);
        };

        self.closePopup = function () {
            $('.popover-inverse').css('display', 'none');
        };

        self.activate = function () {
            return userApi.settings()
                .then(function (userSettings) {
                    self.isWebJoinProvisioned(userSettings.isWebJoinProvisioned);
                    self.descriptionText(userSettings.isWebJoinProvisioned ? i18n.t('settings.webapp.webAppLiteDescription') : i18n.t('settings.webapp.webAppDescription'));
                    self.isWebJoinEnabledSelected(userSettings.isWebJoinEnabled);
                    self.isWebViewerSelected(userSettings.webViewerDefault);
                    self.isOpenPresenterModeSelected(isPresenterModeOpen(userSettings));
                    self.isWebViewerAllowed(userSettings.webViewerAllowed);

                    self.originalSettings({
                        webViewer: userSettings.webViewerDefault,
                        webAppLite: userSettings.isWebJoinEnabled,
                        presenterMode: defaultPresenterMode(userSettings)
                    });

                    var isOrganizerPinEnabled = userSettings.isStandaloneAudioProvisioned && userSettings.isStandaloneAudioEntitled && userSettings.isStandaloneAudioEnabled;
                    var isOpenMeetingFeatureEnabled = userSettings.isOpenMeetingsProvisioned && userSettings.isOpenMeetingsEntitled;
                    self.isOpenPresenterRelatedFeaturesEnabled(isOrganizerPinEnabled || isOpenMeetingFeatureEnabled);
                });
        };

        app.on('attendees:enablePresenterMode').then(function () {
            $('.presenter-swap-wrapper .presenter-swap-spinner .togo-icon-spinner-stack').css('display', 'block');
            userApi
                .updateSettings({
                    presenterMode: toPresenterMode(true)
                })
                .then(function () {
                    self.activate();
                    $('.presenter-swap-wrapper .presenter-swap-spinner .togo-icon-spinner-stack').css('display', 'none');
                });
        });
    };
});

